import { dateDiff } from '@wix/da-ds/pkg/Time/functions';
import { editMessageWindow } from '../constants';

export function getCanEditMessage(
  sentAt: string,
  isAuthorCurrentUser: boolean
) {
  return (
    dateDiff(new Date().toISOString(), sentAt, 'minutes') < editMessageWindow &&
    isAuthorCurrentUser
  );
}
